import { render, staticRenderFns } from "./EdicaoRapida.vue?vue&type=template&id=1fb11eb8&scoped=true"
import script from "./EdicaoRapida.vue?vue&type=script&lang=js"
export * from "./EdicaoRapida.vue?vue&type=script&lang=js"
import style0 from "./EdicaoRapida.vue?vue&type=style&index=0&id=1fb11eb8&prod&lang=css"
import style1 from "./EdicaoRapida.vue?vue&type=style&index=1&id=1fb11eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb11eb8",
  null
  
)

export default component.exports